
export const FlexSectionContainer = (props) => {

    const { title, children } = props;

    return (
        <div className="m-4">
            <span>{title}</span>
            <div className="d-flex my-2">
                {children}
            </div>
        </div>
    );
}